import { BuildingDTO } from "./building";
import { ContractContact, RentalContract } from "./rental-contracts";
import { Resource } from "./resource";
import { UnitDTO } from "./unit";

export interface Contact {
  id?: number;
  firstName: string;
  lastName: string;
  email: string;
  description?: string | null;
  notes?: string | null; // Internal notes/remarks (e.g., for incasso tracking)
  jobTitle: string;
  linkedIn?: string | null;
  ssid?: string | null;
  picture?: string | null;
  tags?: string[];
  odoo_id?: number;
  birthdate?: any | null;
  birthplace?: string | null;
  nationality?: string | null;
  language?: string;
  phone_mobile?: string;
  phone_direct?: string;
  gender?: string | null;
  created_at?: string;
  updated_at?: string;
  archived?: boolean;
  created_company?: CompanyType;
  company?: CompanyType | null;
  address?: any | null;
  sharePointFolderUrl?: string;
  sharePointFolderId?: string;
  gdpr_allowed?: boolean;
  contact_source_info?: string;
}

export type ExtendedContact = Contact & {
  resource: Resource;
  building: BuildingDTO;
  unit: UnitDTO;
  contactRelationToBuildingOrUnit: string;
  contractContact: ContractContact;
  rentalContract: RentalContract;
};

/*interface Address {
  id: number;
  street?: string;
  city?: string;
  postalCode?: string;
  country?: string;
  zip?: string;
  placeId: string | null;
  formattedAddress: string | null;
  created_at?: string;
  updated_at?: string;
}*/

export interface CompanyType {
  id?: number;
  name: string;
  description?: string | null;
  notes?: string | null; // Internal notes/remarks (e.g., for incasso tracking)
  email?: string;
  website?: string;
  kbo_url?: string | null;
  staatsbladmonitor_url?: string | null;
  linkedIn?: string | null;
  facebook?: string | null;
  instagram?: string | null;
  tags?: string[];
  odoo_id?: number;
  phone_direct?: string | null;
  vatNumber?: string | null;
  created_at?: string;
  updated_at?: string;
  archived?: boolean;
  contacts?: Contact[];
  address?: any | null;
  sharePointFolderUrl?: string;
  sharePointFolderId?: string;
}

export enum ContactTags {
  AcademischeInstelling = "Academische instelling",
  MediaCommunicatie = "Media & Communicatie",
  Journalist = "Journalist",
  Media = "Media",
  GroothandelProducten = "Groothandel producten",
  ConsultantMarketingCommunicatie = "Consultant - Marketing en communicatie",
  Notaris = "Notaris",
  Advocaat = "Advocaat",
  ConsultantFinancieel = "Consultant - Financieel",
  Bank = "Bank",
  MakelaarVerzekeringen = "Makelaar - Verzekeringen",
  Verzekeringsmaatschappij = "Verzekeringsmaatschappij",
  Overheid = "Overheid",
  Nutsvoorzieningen = "Nutsvoorzieningen",
  Landmeter = "Landmeter",
  Architect = "Architect",
  Vastgoedbeheerder = "Vastgoedbeheerder",
  ConsultantEnergie = "Consultant - Energie",
  AdviesenIngenieursbureau = "Advies- en ingenieursbureau",
  MakelaarVastgoed = "Makelaar - Vastgoed",
  ConsultantVastgoed = "Consultant - Vastgoed",
  MakelaarBedrijven = "Makelaar - bedrijven",
  AannemerSanitairEnVerwarming = "Aannemer - Sanitair en verwarming",
  AannemerElectro = "Aannemer - Electro",
  AannemerTotaal = "Aannemer - Totaal",
  AannemerRuwbouw = "Aannemer - Ruwbouw",
  AannemerDakwerken = "Aannemer - Dakwerken",
  AannemerAfbraakEnGrondwerken = "Aannemer - Afbraak en grondwerken",
  AannemerAfwerking = "Aannemer - Afwerking",
  LeverancierBouw = "Leverancier - Bouw",
  ConsultantBouw = "Consultant - Bouw",
  Interieur = "Interieur",
  Onderhoud = "Onderhoud",
  OnderhoudKeuring = "Onderhoud - Keuring",
  Leverancier = "Leverancier",
  Projectontwikkelaar = "Projectontwikkelaar",
  Development = "Development",
  Freelancers = "Freelancers",
  ConsultantIT = "Consultant - IT",
  ConsultantHRM = "Consultant - HRM",
  Huurder = "Huurder",
  ExHuurder = "Ex-huurder",
  Retail = "Retail",
  Horeca = "Horeca",
  InvesteerderInstitutioneel = "Investeerder - Institutioneel",
  InvesteerderPrive = "Investeerder - Privé",
  Holding = "Holding",
  Eigenaar = "Eigenaar",
  EigenaarRetail = "Eigenaar retail",
  EigenaarResidentieelVastgoed = "Eigenaar Residentieel Vastgoed",
  BinnenstedelijkCommercieelVastgoed = "Binnenstedelijk Commercieel Vastgoed",
}
